import events from "_src/engine/events";

import {screenUtils} from "_src/client/utils";

let _canvas = null;
let clientHeight = -1;

const _pointTmp = new Array(2);

const _coords = new Array(2);
const _clientCoords = new Array(2);

export default {

  init(canvas) {
    _canvas = canvas;
    canvas.requestPointerLock = canvas.requestPointerLock ||
      canvas.mozRequestPointerLock ||
      canvas.webkitRequestPointerLock;
    document.exitPointerLock = document.exitPointerLock ||
      document.mozExitPointerLock ||
      document.webkitExitPointerLock;

    clientHeight = canvas.offsetHeight;

    initEvents();
  },

  getCoords() {
    return _coords;
  },

  getClientCoords() {
    return _clientCoords;
  },

  clientToPhysical(clientX, clientY) {
    const screenPoint = clientToPhysical(clientX, clientY, _pointTmp)
    const screenX = screenPoint[0];
    const screenY = screenPoint[1];

    return { screenX, screenY };
  },

  mousemoveHandler(clientX, clientY, button, buttons) {
    const physicalPoint = clientToPhysical(clientX, clientY, _pointTmp);

    _clientCoords[0] = clientX;
    _clientCoords[1] = clientY;

    _coords[0] = physicalPoint[0];
    _coords[1] = physicalPoint[1];

    events.emit("client_mousemove", {screenX : _coords[0], screenY : _coords[1], button, buttons});
  },

  mouseupHandler(clientX, clientY, button, buttons) {
    const physicalPoint = clientToPhysical(clientX, clientY, _pointTmp);

    _clientCoords[0] = clientX;
    _clientCoords[1] = clientY;

    _coords[0] = physicalPoint[0];
    _coords[1] = physicalPoint[1];

    events.emit("client_mouseup", {screenX : _coords[0], screenY : _coords[1], button, buttons});
  },

  mousedownHandler(clientX, clientY, button, buttons) {
    const physicalPoint = clientToPhysical(clientX, clientY, _pointTmp);

    _clientCoords[0] = clientX;
    _clientCoords[1] = clientY;

    _coords[0] = physicalPoint[0];
    _coords[1] = physicalPoint[1];

    events.emit("client_mousedown", {screenX : _coords[0], screenY : _coords[1], button, buttons});
  },

  cleanup() {
    _canvas = null;
    cleanupEvents();
  }
}

function initEvents() {
  events.on("resize", resizeHandler);
  events.on("lock_cursor", cursorLockHandler);
  events.on("unlock_cursor", cursorUnlockHandler);
}

function cleanupEvents() {
  events.off("resize", resizeHandler);
  events.off("lock_cursor", cursorLockHandler);
  events.off("unlock_cursor", cursorUnlockHandler);
}

function resizeHandler() {
  clientHeight = _canvas.offsetHeight;
}

function cursorLockHandler() {
  _canvas.requestPointerLock();
}

function cursorUnlockHandler() {
  document.exitPointerLock();
}

const clientToPhysical = (function() {

  const virtualPoint = [-1, -1];

  return function(clientX, clientY, dest) {
    virtualPoint[0] = clientX;
    virtualPoint[1] = clientHeight - clientY;

    return screenUtils.virtualPointToPhysical(dest, virtualPoint);
  }

})();

